import { useQuery } from "react-query";
import useRequest from "./useRequest";
import { toast } from "react-toastify";

export const useQueries = (
  url: string,
  queryKey: (string | number | undefined)[],
  options?: any,
  headers?: object
) => {
  const { request } = useRequest(url, "get", headers);
  return useQuery(queryKey, () => request(url), {
    onError: (error: any) => {
      toast.error(error.response.data.message);
    },
    ...options,
  });
};
